import { useEffect } from "react";
import { useMySPHLightbox } from "@sphtech/idpf-lightbox-react";

/**
 * This component is used to refresh the authentication of the user when session-refresh is 1
 */
const RefreshAuthWithRedirect = () => {
  const { lightbox } = useMySPHLightbox();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!lightbox) return;

    const url = new URL(window.location.href);
    const sessionRefresh = url.searchParams.get("session-refresh");

    // Explicit allow-list check (important for CodeQL)
    if (sessionRefresh !== "1") return;

    // Remove the parameter safely to prevent infinite loop
    url.searchParams.delete("session-refresh");

    // Update browser URL without triggering navigation
    window.history.replaceState({}, "", url.toString());

    if (typeof lightbox.authWithRedirect !== "function") return;

    lightbox.authWithRedirect();
  }, [lightbox]);

  return <></>;
};

export default RefreshAuthWithRedirect;
